import { render, staticRenderFns } from "./ImageContent.vue?vue&type=template&id=37e8ed86&scoped=true&"
import script from "./ImageContent.vue?vue&type=script&lang=js&"
export * from "./ImageContent.vue?vue&type=script&lang=js&"
import style0 from "./ImageContent.vue?vue&type=style&index=0&id=37e8ed86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8ed86",
  null
  
)

export default component.exports